import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

const Home = lazy(() => import("../Pages/Home/Home"));
const About = lazy(() => import("../Pages/About/About"));
const SearchPage = lazy(() => import("../Pages/SearchPage/SearchPage"));
const Articles = lazy(() => import("../Pages/Articles/Articles"));
const ArticleDetails = lazy(() => import("../Pages/ArticleDetails/ArticleDetails"));
const Teams = lazy(() => import("../Pages/Teams/Teams"));
const Clients = lazy(() => import("../Pages/Clients/Clients"));
const PrivacyPolicy = lazy(() => import("../Pages/PrivacyPolicy/PrivacyPolicy"));
const PropertyContact = lazy(() => import("../Pages/PropertyContact/PropertyContact"));
const PropertyContactForm = lazy(() => import("../Pages/PropertyContactForm/PropertyContactForm"));
const Csr = lazy(() => import("../Pages/Csr/Csr"));
const MandatedPropertiesResults = lazy(() => import("../Pages/MandatedPropertiesResults/MandatedPropertiesResults"));
const Career = lazy(() => import("../Pages/Career/Career"));
const CareerDetails = lazy(() => import("../Pages/CareerDetails/CareerDetails"));
const Rewards = lazy(() => import("../Pages/Rewards/Rewards"));
const ContactUs = lazy(() => import("../Pages/ContactUs/ContactUs"));
const NewsRoom = lazy(() => import("../Pages/NewsRoom/NewsRoom"));
const ErrorPage = lazy(() => import("../Pages/404/ErrorPage"));
const MandatedProperties = lazy(() => import("../Pages/MandatedProperties/MandatedProperties"));
const MandatedPropertiesInternal = lazy(() => import("../Pages/MandatedPropertiesInternal/MandatedPropertiesInternal"));
const Account = lazy(() => import("../Components/Account/Account"));
const InteriorManagement = lazy(() => import("../Pages/Services/InteriorManagement"));
const CorporateService = lazy(() => import("../Pages/Services/CorporateServices"));
const RetailServices = lazy(() => import("../Pages/Services/RetailServices"));
const InvestmentAdvisory = lazy(() => import("../Pages/Services/InvestmentAdvisory"));
const HomeSlider = lazy(() => import("../Pages/Home/HomeSlider"));
const Warehousesservices = lazy(() => import("../Pages/Services/Warehouseservices"));
const Listyourproperty = lazy(() => import("../Components/Listyourproperty"));
const Megaheader = lazy(() => import("../Components/Header/Megaheader"));
const Mainbaner = lazy(() => import("../Pages/Home/Mainbaner"));
const ApplyJob = lazy(() => import("../Pages/Career/ApplyJob"));
const CaseStudiesDetails = lazy(() => import("../Pages/ArticleDetails/CaseStudiesDetails"));
const MultipalSlider = lazy(() => import("../Pages/Testingpages/MultipalSlider"));
const DetailsSlider = lazy(() => import("../Pages/Testingpages/DetailsSlider"));
const CaseStudies = lazy(() => import("../Pages/Articles/CaseStudies"));
const Propertiesforlease = lazy(() => import("../Pages/MandatedProperties/Propertiesforlease"));
const Propertiesforsale = lazy(() => import("../Pages/MandatedProperties/Propertiesforsale"));
const PropertyContactFormWarehouse = lazy(() => import("../Pages/PropertyContactForm/PropertyContactFormWarehouse"));
const PropertyContactFormCorporate = lazy(() => import("../Pages/PropertyContactForm/PropertyContactFormCorporate"));
const PropertyContactFormInterior = lazy(() => import("../Pages/PropertyContactForm/PropertyContactFormInterior"));
const PropertyContactFormInvestmentAdvisory = lazy(() => import("../Pages/PropertyContactForm/PropertyContactFormInvestmentAdvisory"));
const PropertyContactFormRetail = lazy(() => import("../Pages/PropertyContactForm/PropertyContactFormRetail"));
const Csrimgdetail = lazy(() => import("../Pages/Csr/Csrimgdetail"));
const Blogs = lazy(() => import("../Pages/Blogs/Blogs"));
const Blog = lazy(() => import("../Pages/Blogs/Blog"));
const ListPopup = lazy(() => import("../Components/ListPopup"));
const LandingPage = lazy(() => import("../Pages/LandingPage/LandingPage"));
const Landing = lazy(() => import("../Pages/LandingPage/Landing"));
const Insights = lazy(() => import("../Pages/Insights/Insights"));
const OurPhilosophy = lazy(() => import("../Pages/OurPhilosophy/OurPhilosophy"));

// With fallback=null, the page collapsed to header+footer while a route's lazy
// chunk was loading (footer would flash near the top), then jumped as the real
// content mounted and grew. A minHeight:100vh fallback keeps page height stable
// during route transitions too.
const RouteFallback = () => <div style={{ minHeight: "100vh" }} />;

const ScreenRouter = () => {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="*" element={<Navigate to="/404" replace />} />
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/banner_image" element={<Home />} />

        <Route path="/aboutus" element={<About />} />
        <Route path="/life@rr" element={<About />} />


        <Route path="/insights" element={<Insights />} />
        <Route path="/Insights" element={<Insights />} />

        <Route path="/search" element={<SearchPage />} />
        <Route path="/market_trends" element={<Articles />} />
        <Route path="/article-details" element={<ArticleDetails />} />
        <Route path="/team@rr" element={<Teams />} />
        <Route path="/team@rr_category" element={<Teams />} />

        <Route path="/leadership" element={<Teams />} />

        <Route path="/executives" element={<Teams />} />

        <Route path="/our-clients" element={<Clients />} />
        <Route path="/services" element={<Home />} />
        <Route path="/interior_management" element={<InteriorManagement />} />
        <Route
          path="/interior_service_gallery"
          element={<InteriorManagement />}
        />

        <Route path="/corporate_leasing" element={<CorporateService />} />
        <Route
          path="/corporate_service_gallery"
          element={<CorporateService />}
        />

        <Route path="/retail_services" element={<RetailServices />} />
        <Route path="/investment_advisory" element={<InvestmentAdvisory />} />
        <Route
          path="/investment_service_gallery"
          element={<InvestmentAdvisory />}
        />

        <Route path="/warehouse_services" element={<Warehousesservices />} />
        <Route
          path="/warehouse_service_gallery"
          element={<Warehousesservices />}
        />

        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/propertycontact" element={<PropertyContact />} />
        <Route path="/propertycontactform" element={<PropertyContactForm />} />
        <Route path="/csr" element={<Csr />} />
        <Route path="retail_service_gallery" element={<RetailServices />} />
        <Route path="retail_services_gallery" element={<RetailServices />} />

        <Route path="/career" element={<Career />} />
        <Route path="/career-details" element={<CareerDetails />} />
        <Route path="/awards" element={<Rewards />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/media" element={<NewsRoom />} />
        <Route path="/news" element={<NewsRoom />} />

        <Route path="/articles" element={<NewsRoom />} />

        <Route path="/properties" element={<MandatedProperties />} />
        <Route path="/property_type" element={<MandatedProperties />} />

        <Route path="/property_location" element={<MandatedProperties />} />

        <Route path="/property_experts" element={<MandatedProperties />} />

        <Route path="/create_property" element={<MandatedProperties />} />

        <Route
          path="/mandated-properties-results"
          element={<MandatedPropertiesResults />}
        />
          <Route
            path="/property"
            element={<MandatedPropertiesInternal />}
          />
          <Route
            path="/property/:identifier"
            element={<MandatedPropertiesInternal />}
          />
        <Route path="/404" element={<ErrorPage />} />
        <Route path="/account" element={<Account />} />
        <Route path="/HomeSlider" element={<HomeSlider />} />
        <Route path="/form" element={<Listyourproperty />} />
        <Route path="/Listyourproperty" element={<Home />} />

        <Route path="/ListPopup" element={<ListPopup />} />
        <Route path="/Megaheader" element={<Megaheader />} />
        <Route path="/Mainbaner" element={<Mainbaner />} />
        <Route path="/ApplyJob" element={<ApplyJob />} />
        <Route path="/MultipalSlider" element={<MultipalSlider />} />
        <Route path="/DetailsSlider" element={<DetailsSlider />} />
        <Route path="/CaseStudiesDetails" element={<CaseStudiesDetails />} />
        <Route path="/casestudy" element={<CaseStudies />} />


        <Route path="/Propertiesforlease" element={<Propertiesforlease />} />
        <Route path="/Propertiesforsale" element={<Propertiesforsale />} />
        <Route
          path="/PropertyContactFormRetail"
          element={<PropertyContactFormRetail />}
        />
        <Route
          path="/PropertyContactFormInvestmentAdvisory"
          element={<PropertyContactFormInvestmentAdvisory />}
        />
        <Route
          path="/PropertyContactFormInterior"
          element={<PropertyContactFormInterior />}
        />
        <Route
          path="/PropertyContactFormCorporate"
          element={<PropertyContactFormCorporate />}
        />
        <Route
          path="/PropertyContactFormWarehouse"
          element={<PropertyContactFormWarehouse />}
        />
        <Route path="/Csrimgdetail" element={<Csrimgdetail />} />
        <Route path="/Blogs" element={<Blogs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<Blog />} />
        <Route path="/landingPage" element={<LandingPage />} />
        <Route path="/landing" element={<Landing />} />
        <Route path="/our-philosophy" element={<OurPhilosophy />} />

      </Routes>
    </Suspense>
  );
};

export default ScreenRouter;
